import { render, staticRenderFns } from "./DictItemModal.vue?vue&type=template&id=c54dea54"
import script from "./DictItemModal.vue?vue&type=script&lang=js"
export * from "./DictItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c54dea54')) {
      api.createRecord('c54dea54', component.options)
    } else {
      api.reload('c54dea54', component.options)
    }
    module.hot.accept("./DictItemModal.vue?vue&type=template&id=c54dea54", function () {
      api.rerender('c54dea54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DictItemModal.vue"
export default component.exports